module.exports = __webpack_public_path__ + "img/box-arrow-in-right.ef667963.svg";